import {Component, Input} from '@angular/core';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {ValidationHandlerService} from '../validation-handler.service';

@Component({
  selector: 'achoo-radio-button',
  templateUrl: './achoo-radio-button.component.html',
  styleUrls: ['./achoo-radio-button.component.scss']
})
export class AchooRadioButtonComponent extends AchooInputComponent<any> {
  @Input() value: string | number;

  constructor(protected validationHandlerService: ValidationHandlerService) {
    super(validationHandlerService);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-radio-button/achoo-radio-button.component.ts